import script from "./powerStation.vue?vue&type=script&setup=true&lang=js"
export * from "./powerStation.vue?vue&type=script&setup=true&lang=js"

import "./powerStation.vue?vue&type=style&index=0&id=7ac31c18&lang=less"

const __exports__ = script;

export default __exports__